// @flow

import React from 'react';

import './ProjectsPage.css';
import { Project } from './Project'

import trackit from '../img/projects/trackit.jpg'
import lanedetect from '../img/projects/lane-detect.png'
import pcb from '../img/projects/pcb.png'
import compiler from '../img/projects/compiler.png'
import hackmit from '../img/projects/hackmit.png'
import hackscience from '../img/projects/hackscience.jpg'
import pibot from '../img/projects/pibot.jpg'

import type { ProjectProps } from './Project'

const projects = [
  // TODO: put pics
  // {
  //   'Title': 'Spacescape (WIP)',
  //   'img': 'trackit.jpg',
  //   'Date': 'July 2018',
  //   'Reason': 'Leisure',
  //   'Languages': 'Arduino C, python',
  //   'Link': ['Github repo', 'https://github.com/belenbarbed/Spacescape'],
  //   'Summary': 'A WIP single-person escape room with a space theme being developed as part of ICAH\'s "Summer of Hack" which will be shown at the 2018 Electromagnetic Camp.'
  // },
  // {
  //   'Title': 'Amazon Global Intern Hackathon',
  //   'img': 'trackit.jpg',
  //   'Date': 'July 2018',
  //   'Reason': 'Internship at Amazon Video',
  //   'Languages': 'JS, python',
  //   'Link': ['Alexa Skill', 'somethingsomething.com'],
  //   'Summary': 'As part of my 6-month internship at Amazon Video, I participated in the Global Intern Hackathon, where SDE interns at Amazon all around the globe do a full day of hacking centred around an Alexa skill. Our skill, \'Nosh Mama\', is activated when tell the Echo device you want to cook a specific dish. The skill will then query a million-entry recipe database and return the necessary ingredents. After customer confirmation, those items will be purchased off Amazon Pantry or Fresh, and the customer will be able to make their dish of choice hassle-free.' 
  // },
  {
    'Title': 'TrackIt: An IoT Running Companion',
    'img': trackit,
    'Date': 'March 2018',
    'Reason': 'Uni',
    'Course': 'Embedded Systems',
    'Languages': '(micro)python',
    'Link': ['Github repo', 'https://github.com/belenbarbed/EE3-IoT'],
    'Summary': 'For this course, we were given the task of designing an IoT system around a randomly-selected sensor and a ESP826 board. My team (right to left: Mwana Hussein, Zoe Slattery and myself) were given a 3D accelerometer, with which we decided to make a running companion.<br />The device used arm movement to calculate the user\'s pace in beats per minute (bpm) and would play a song from a designated playlist that had that beat so it would be enjoyable to maintain a constant pace.'
  },
  {
    'Title': 'Real-time Lane Detection',
    'img': lanedetect,
    'Date': 'September 2017',
    'Reason': 'Internship at DROTIUM',
    'Languages': 'python',
    'Summary': 'Last summer, I spent some months intering at <a href="https://drotium.com/">DROTIUM</a>, a start-up supported by <a href="http://www.auvsi.org/">AUVSI</a> (Association for Unmanned Vehicle Systems International), developing Autonomous Systems for unmanned vehicles with the objective of fully automating Spain\'s transport system by 2040.<br />Using Computer Vision, an old raspberry pi, and some dashcam footage, this real-time python script was able to detect lane lines and point the autonomous car in the right direction.'
  },
  {
    'Title': 'PCB Touch-Switch Design and Wave Generation',
    'img': pcb,
    'Date': 'May 2017',
    'Reason': 'Uni',
    'Course': 'Electronics Lab',
    'Languages': 'C++',
    'Link': ['Github repo', 'https://github.com/belenbarbed/EE2-Switch'],
    'Summary': 'The first stage of this assignment was to design a PCB with 4 touch capacitors to use as buttons, a simple ARM chip to drive a small LCD screen, and a DAC for signal output.<br />After getting our designed boards manufactured, my project partner and I programmed it to output waves at different frequencies and shapes (square, triangle, sine...) as chosen by the user through the buttons and screen.'
  },
  {
    'Title': 'ANSI C Compiler',
    'img': compiler,
    'Date': 'March 2017',
    'Reason': 'Uni',
    'Course': 'Language Processors',
    'Languages': 'C++, Yacc, Lex, Shell',
    'Link': ['Github repo', 'https://github.com/belenbarbed/EE2-Compiler'],
    'Summary': 'This is possibly one of the largets projects I\'ve undertaken to date: making a C to assembly compiler from scratch, which included writing a lexer, a parser and even its own stack tracking for more efficient use of memory during runtime.<br />The assignment included writing an automated tests suite with bash, possibly one of the most important learning outcumes from this project.'
  },
  {
    'Title': 'HackMIT 2016',
    'img': hackmit,
    'Date': 'September 2016',
    'Reason': 'Leisure',
    'Languages': 'python, HTML/CSS',
    'Link': ['Hackathon page', 'https://hackmit.org/2016/'],
    'Summary': 'A group of friends and I received grant to attend the HackMIT hackathon held at MIT. The theme was completely open, so we developed an online checkout system that we could use at ICRS to sell materials, electronics and more.<br />The project consisted of the web interface (which I was responsible for), a database to hold user\'s credit and product pricing, and a streamlined backend to perform all these operations safely while also integrating with our existing shop.'
  },
  {
    'Title': 'HackScience - Automate Imperial',
    'img': hackscience,
    'Date': 'January 2016',
    'Reason': 'Leisure',
    'Languages': 'Arduino C',
    'Link': ['Project page', 'https://hackscience.io/project/vacngo/'],
    'Summary': 'This hackathon was themed around automating time-consuming processes in lab experiments, and the teams were comprised of one researcher with a problem they\'d like to solve and a couple of engineers who could help them solve it.<br />In order to avoid queues, our researcher was looking to have his own portable vacuum oven to safely dry his chemical samples. We built the entire project from scratch, and I was responsible for designing and programming the control system for it.'
  },
  {
    'Title': 'Pibot',
    'img': pibot,
    'Date': 'July 2015',
    'Reason': 'Leisure',
    'Languages': 'Arduino C',
    'Link': ['Product page', 'http://www.stemcenterusa.com/pi-bot/about-pi-bot/'],
    'Summary': 'To get a head-start on university and learn about robotics, I taught myself basic C programming and made a robot that could avoid obstacles, traverse mazes, and follow lines on the ground.'
  }
];

export const ProjectsPage = () => {

  const projectsHTML = projects.map(
    (item) => {
      const props : ProjectProps = {
        title: item.title,
        img: item.img,
        date: item.date,
        reason: item.reason,
        course: item.course ? item.course : null,
        languages: item.languages ? item.languages : null,
        link: item.link ? item.link : null,
        summary: item.summary,
      }
      return <Project {...props} />
    }
  )

  return(
    <div className="projects-page">
      <div className="projects-table">
        {projectsHTML}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/ProjectsPage/ProjectsPage.js